import { createApi } from '@reduxjs/toolkit/query/react';
import type {
    GetMemberPrefilledPackagingCostApiResponse,
    UpdateMemberPrefilledPackagingCostApiRequest,
    UpdateMemberPrefilledPackagingCostApiResponse,
} from 'tradera/state/services/types/webapi-selling-generated';

import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';

export const memberPrefilledPackagingCostApi = createApi({
    reducerPath: 'memberPrefilledPackagingCostApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getMemberPrefilledPackagingCost: builder.query<
            GetMemberPrefilledPackagingCostApiResponse,
            void
        >({
            query: () => {
                return `/api/webapi/selling/member-prefilled-packaging-cost`;
            },
        }),
        setMemberPrefilledPackagingCost: builder.mutation<
            UpdateMemberPrefilledPackagingCostApiResponse,
            UpdateMemberPrefilledPackagingCostApiRequest
        >({
            query: (body) => {
                return {
                    url: `/api/webapi/selling/member-prefilled-packaging-cost`,
                    method: 'POST',
                    body,
                };
            },
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                const patchResult = dispatch(
                    memberPrefilledPackagingCostApi.util.updateQueryData(
                        'getMemberPrefilledPackagingCost',
                        undefined,
                        (draft) => {
                            Object.assign(draft, {
                                packagingCost: arg.packagingCost,
                            });
                        },
                    ),
                );

                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
        }),
    }),
});

export const {
    useGetMemberPrefilledPackagingCostQuery,
    useSetMemberPrefilledPackagingCostMutation,
} = memberPrefilledPackagingCostApi;
